// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"239":"data-holidays","628":"drift","979":"swiper"}[chunkId] + ".js?v=" + {"239":"3e06d8905e0a151df2a2","628":"49dd47686791868fca76","979":"613be89f4ee70009762f"}[chunkId] + "";
};